// components/ScoreBadge.js
// Propósito: Mostrar badge de puntuación con color según nivel.
// Por qué: Ayuda a comunicar de forma rápida el estado general.

import React from 'react';

function getVariant(score) {
  if (score > 66) return 'success';
  if (score >= 34) return 'warning';
  return 'danger';
}

function ScoreBadge({ score = 0 }) {
  const numeric = Number(score) || 0;
  const variant = getVariant(numeric);
  return (
    <span className={`score-chip score-chip--${variant}`}>
      Seguridad: {numeric} / 100
    </span>
  );
}

export default ScoreBadge;
